import {
  Alert,
  AlertTitle,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { motion } from "framer-motion";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  COLUMNSVACACIONES,
  COLUMNSVACACIONESAPROBADAS,
  COLUMNSVACACIONESINGRESADAS,
  COLUMNSVACACIONESNEQUIPOAPROBADAS,
  COLUMNSVACACIONESNEQUIPOINGRESADAS,
  COLUMNSVACACIONESNEQUIPONOADMI,
  COLUMNSVACACIONESNOAPROBADAS,
} from "../columnas/ColumnasVacaciones";
import Header from "./Header";

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";

import moment from "moment/moment";
import { useEffect, useState } from "react";
import {
  aprobarRechazarLicencia,
  cancelarVacacionesMetodo,
  solicitudVacaciones,
  vacaciones,
  vacacionesAprobadas,
  vacacionesAprobadasEquipo,
  vacacionesIngresadas,
  vacacionesIngresadasEquipoFetch,
  vacacionesNoAprobadas,
  vacacionesNoAprobadasEquipoFetch,
} from "../Redux/vacaciones";
import { UserAuth } from "../context/AuthContext";
import TokenContext from "../context/TokenContext";
import Tabla from "./Tabla";
import ModalCancelarVacaciones from "./modales/ModalCancelarVacaciones";
import ModalSolicitudVacaciones from "./modales/ModalSolicitudVacaciones";
import ModalVacacionesEquipo from "./modales/ModalVacacionesEquipo";
import { useLocation, useNavigate } from "react-router-dom";
import { analytics } from '../Firebase'
import TablaVacaciones from "./tablas/TablaVacaciones";
import useLider from "./hooks/useLider";
const Vacaciones = () => {
  const dispatch = useDispatch();
  const token = useContext(TokenContext);
  const { empleado } = UserAuth();
  const { lider } = useLider()

  const navigate = useNavigate()
  const location = useLocation();
  const [valuePrimerTab, setValuePrimerTab] = React.useState("1"); //value del tablist
  const [valueSegundoTab, setValueSegundoTab] = React.useState("1"); //value del tablist

  const vacacionesSelector = useSelector((store) => store.vacaciones.vacaciones);
  const getVacacionesSelector = useSelector((store) => store.vacaciones.getVacaciones);
  const [getVacaciones, setGetVacaciones] = React.useState(false);
  const [periodoVacaciones, setPeriodoVacaciones] = useState([]);


  const vacacionesIngresadasSelector = useSelector((store) => store.vacaciones.vacacionesIngresadas);
  const getVacacionesIngresadasSelector = useSelector((store) => store.vacaciones.getVacacionesIngresadas);
  const [getVacacionesIngresadas, setGetVacacionesIngresadas] = React.useState(false);
  const [vacacioneIngresada, setVacacioneIngresada] = useState([]);

  const vacacionesAprobadasSelector = useSelector((store) => store.vacaciones.vacacionesAprobadas);
  const getVacacionesAprobadasSelector = useSelector((store) => store.vacaciones.getVacacionesAprobadas);
  const [getVacacionesAprobadas, setGetVacacionesAprobadas] = React.useState(false);
  const [vacacioneAprobadas, setVacacioneAprobadas] = useState([]);

  const noAprobadasSelector = useSelector((store) => store.vacaciones.vacacionesNoAprobadas);
  const getVacacionesNoAprobadasSelector = useSelector((store) => store.vacaciones.getVacacionesNoAprobadas);
  const [getVacacionesNoAprobadas, setGetVacacionesNoAprobadas] = React.useState(false);
  const [vacacionesNoAprob, setVacacionesNoAprob] = useState([]);

  const vacacionesIngresadasEquipoSelector = useSelector((store) => store.vacaciones.vacacionesIngresadasEquipo);
  const getVacacionesIngresadasEquipoSelector = useSelector((store) => store.vacaciones.getVacacionesIngresadasEquipo);
  const [getVacacionesIngresadasEquipo, setGetVacacionesIngresadasEquipo] = React.useState(false);
  const [vacacionesIngresadasEquipo, setVacacionesIngresadasEquipo] = useState([]);

  const vacacionesAprobadasEquipoSelector = useSelector((store) => store.vacaciones.vacacionesAprobadasEquipo);
  const getVacacionesAprobadasEquipoSelector = useSelector((store) => store.vacaciones.getVacacionesAprobadasEquipo);
  const [getVacacionesAprobadasEquipo, setGetVacacionesAprobadasEquipo] = React.useState(false);
  const [vacacionesEquipoAprobadas, setVacacionesAprobadasEquipo] = useState([]);

  const vacacionesNoAprobadasEquipoSelector = useSelector((store) => store.vacaciones.vacacionesNoAprobadasEquipo);
  const getVacacionesNoAprobadasEquipoSelector = useSelector((store) => store.vacaciones.getVacacionesNoAprobadasEquipo);
  const [getVacacionesNoAprobadasEquipo, setGetVacacionesNoAprobadasEquipo] = React.useState(false);
  const [vacacionesIngresadasEquipoNoAdmi, setVacacionesIngresadasEquipoNoAdmi,] = useState([]);

  const [openModalVacacionesEquipo, setOpenModalModalVacacionesEquipo] = React.useState(false);
  const [vacacion, setVacacion] = useState({});
  const [openSolicitud, setOpenSolicitud] = React.useState(false);
  const [openCancelar, setOpenCancelar] = React.useState(false);
  const fecha = moment();
  const fechaHoy = fecha.format('YYYY/MM/DD');

  React.useEffect(() => {
    if (empleado && empleado.usuarioPortalRh) {
      // Extraer el nombre de usuario de la dirección de correo electrónico
      const userEmail = empleado.usuarioPortalRh;
      const userName = userEmail.split('@')[0];

      // Enviar el evento a Firebase Analytics con el nombre de usuario
      analytics.logEvent('screen_view', {
        screen_name: location.pathname,
        user_email: userName,
      });
    }
  }, [empleado, location]);

  useEffect(() => {
    if (token && Object.keys(empleado).length > 0) {
      dispatch(vacaciones(token, fechaHoy, empleado.usuarioPortalRh));
      dispatch(vacacionesIngresadas(token, empleado.usuarioPortalRh));
      dispatch(vacacionesAprobadas(token, empleado.usuarioPortalRh));
      dispatch(vacacionesNoAprobadas(token, empleado.usuarioPortalRh));
      dispatch(
        vacacionesIngresadasEquipoFetch(token, empleado.usuarioPortalRh)
      );
      dispatch(vacacionesAprobadasEquipo(token, empleado.usuarioPortalRh));
      dispatch(
        vacacionesNoAprobadasEquipoFetch(token, empleado.usuarioPortalRh)
      );
    }
  }, [token, empleado]);

  useEffect(() => {
    if (vacacionesSelector?.length > 0 && getVacacionesSelector) {
      const array = [];
      vacacionesSelector.forEach((element) => {
        const obj = {
          id: element.new_vacacionesid,
          periodo: element["_new_periodovacacional_value@OData.Community.Display.V1.FormattedValue"],
          periodo_value: element._new_periodovacacional_value,
          diasCorrespondientes: element.new_diasvacacionescorrespondientes,
          diasSolicitados: element.new_totaldiassolicitados ? element.new_totaldiassolicitados : 0,
          diasGozados: element.new_diasvacacionestomados,
          diasPendientes: element.new_diasvacacionespendientes,
          diasAdicionales: element.new_diasvacacionesadicionales,
        };
        array.push(obj);
      });
      setPeriodoVacaciones(array);
      setGetVacaciones(getVacacionesSelector);
    } else if (vacacionesSelector?.length === 0 && getVacacionesSelector) {
      setGetVacaciones(getVacacionesSelector);
    }
  }, [vacacionesSelector, getVacacionesSelector])

  useEffect(() => {

    if (
      vacacionesIngresadasSelector?.length > 0 &&
      getVacacionesIngresadasSelector
    ) {
      const array = [];
      vacacionesIngresadasSelector.forEach((element) => {
        const obj = {
          id: element["new_licenciaid"],
          name: element.new_name,
          new_tipodelicencia: element["_new_tipodelicencia_value@OData.Community.Display.V1.FormattedValue"],
          new_empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],  
          fechaSolicitud: element["new_fechadesolicitud@OData.Community.Display.V1.FormattedValue"],
          fechaDesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          fechaHasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          diasSolicitados: element["new_diassolicitados"],
          estado: element["statuscode"],
        };
        array.push(obj);
      });
      setVacacioneIngresada(array);
      setGetVacacionesIngresadas(getVacacionesIngresadasSelector);
    } else if (
      vacacionesIngresadasSelector?.length === 0 &&
      getVacacionesIngresadasSelector
    ) {
      setGetVacacionesIngresadas(getVacacionesIngresadasSelector);
    }
    if (
      vacacionesAprobadasSelector?.length > 0 &&
      getVacacionesAprobadasSelector
    ) {
      const array = [];
      vacacionesAprobadasSelector.forEach((element) => {
        const obj = {
          id: element["new_licenciaid"],
          name: element.new_name,
          new_tipodelicencia: element["_new_tipodelicencia_value@OData.Community.Display.V1.FormattedValue"],
          new_empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],  
          fechaSolicitud: element["new_fechadesolicitud@OData.Community.Display.V1.FormattedValue"],
          fechaDesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          fechaHasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          diasSolicitados: element["new_diassolicitados"],
          estado: element["statuscode"],
          diasPendientes: element["ad.new_diasvacacionespendientes"],
        };
        array.push(obj);
      });
      setVacacioneAprobadas(array);
      setGetVacacionesAprobadas(getVacacionesAprobadasSelector);
    } else if (
      vacacionesAprobadasSelector?.length === 0 &&
      getVacacionesAprobadasSelector
    ) {
      setGetVacacionesAprobadas(getVacacionesAprobadasSelector);
    }
    if (noAprobadasSelector?.length > 0 && getVacacionesNoAprobadasSelector) {
      const array = [];
      noAprobadasSelector.forEach((element) => {
        let objeto = {
          id: element["new_licenciaid"],
          name: element.new_name,
          new_tipodelicencia: element["_new_tipodelicencia_value@OData.Community.Display.V1.FormattedValue"],
          new_empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],  
          fechaSolicitud: element["new_fechadesolicitud@OData.Community.Display.V1.FormattedValue"],
          fechaDesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          fechaHasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          diasSolicitados: element.new_diassolicitados,
          estado: element["statuscode"],
        };
        array.push(objeto);
      });
      setVacacionesNoAprob(array);
      setGetVacacionesNoAprobadas(getVacacionesNoAprobadasSelector);
    } else if (
      noAprobadasSelector?.length === 0 &&
      getVacacionesNoAprobadasSelector
    ) {
      setGetVacacionesNoAprobadas(getVacacionesNoAprobadasSelector);
    }
    if (
      vacacionesIngresadasEquipoSelector?.length > 0 &&
      getVacacionesIngresadasEquipoSelector
    ) {
      const array = [];
      vacacionesIngresadasEquipoSelector.forEach((element) => {
        let objeto = {
          id: element["new_licenciaid"],
          name: element.new_name,
          new_tipodelicencia: element["_new_tipodelicencia_value@OData.Community.Display.V1.FormattedValue"],
          new_empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],  
          tipoDeLicencia: {
            value: element["_new_tipodelicencia_value"],
            label: element["_new_tipodelicencia_value@OData.Community.Display.V1.FormattedValue"],
          },
          fechaSolicitud: element["new_fechadesolicitud@OData.Community.Display.V1.FormattedValue"],
          fechaSolicitudModal: moment(element["new_fechadesolicitud@OData.Community.Display.V1.FormattedValue"], "DD/MM/YY").format("YYYY-MM-DD"),
          fechaDesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          fechaHasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          fechaHastaModal: moment(element["new_fechahasta@OData.Community.Display.V1.FormattedValue"], "DD/MM/YY").format("YYYY-MM-DD"),
          diasSolicitados: element.new_diassolicitados,
          estado: element["statuscode"],
          subperiodovacacionaldefinido: {
            value: element["_new_subperiodovacacionaldefinido_value"],
            label: element["_new_subperiodovacacionaldefinido_value@OData.Community.Display.V1.FormattedValue"],
          },
          nombreAprobador1: element["_new_aprobador1_value@OData.Community.Display.V1.FormattedValue"],
          iDnombreAprobador1: element["_new_aprobador1_value"],
          nombreAprobador2: element["_new_aprobador2_value@OData.Community.Display.V1.FormattedValue"],
          iDnombreAprobador2: element["_new_aprobador2_value"],
          nombreAprobador3: element["_new_aprobador3_value@OData.Community.Display.V1.FormattedValue"],
          iDnombreAprobador3: element["_new_aprobador3_value"],
          usuarioPortalAprobador1: element["new_usuarioportalaprobador1"],
          usuarioPortalAprobador2: element["new_usuarioportalaprobador2"],
          usuarioPortalAprobador3: element["new_usuarioportalaprobador3"],
        };
        array.push(objeto);
      });
      setVacacionesIngresadasEquipo(array);
      setGetVacacionesIngresadasEquipo(getVacacionesIngresadasEquipoSelector);
    } else if (
      vacacionesIngresadasEquipoSelector?.length === 0 &&
      getVacacionesIngresadasEquipoSelector
    ) {
      setGetVacacionesIngresadasEquipo(getVacacionesIngresadasEquipoSelector);
    }
    if (
      vacacionesAprobadasEquipoSelector?.length > 0 &&
      getVacacionesAprobadasEquipoSelector
    ) {
      const array = [];
      vacacionesAprobadasEquipoSelector.forEach((element) => {
        let objeto = {
          id: element["new_licenciaid"],
          name: element.new_name,
          new_tipodelicencia: element["_new_tipodelicencia_value@OData.Community.Display.V1.FormattedValue"],
          new_empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],  
          fechaSolicitud: element["new_fechadesolicitud@OData.Community.Display.V1.FormattedValue"],
          fechaDesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          fechaHasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          diasSolicitados: element.new_diassolicitados,
          estado: element["statuscode"],
          diasPendientes: element["ad.new_diasvacacionespendientes"],
        };
        array.push(objeto);
      });
      setVacacionesAprobadasEquipo(array);
      setGetVacacionesAprobadasEquipo(getVacacionesAprobadasEquipoSelector);
    } else if (
      vacacionesAprobadasEquipoSelector?.length === 0 &&
      getVacacionesAprobadasEquipoSelector
    ) {
      setGetVacacionesAprobadasEquipo(getVacacionesAprobadasEquipoSelector);
    }
    if (
      vacacionesNoAprobadasEquipoSelector?.length > 0 &&
      getVacacionesNoAprobadasEquipoSelector
    ) {
      const array = [];
      vacacionesNoAprobadasEquipoSelector.forEach((element) => {
        let objeto = {
          id: element["new_licenciaid"],
          name: element.new_name,
          new_tipodelicencia: element["_new_tipodelicencia_value@OData.Community.Display.V1.FormattedValue"],
          new_empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],  
          fechaSolicitud: element["new_fechadesolicitud@OData.Community.Display.V1.FormattedValue"],
          fechaDesde: element["new_fechadesde@OData.Community.Display.V1.FormattedValue"],
          fechaHasta: element["new_fechahasta@OData.Community.Display.V1.FormattedValue"],
          diasSolicitados: element.new_diassolicitados,
          estado: element["statuscode"],
        };
        array.push(objeto);
      });
      setVacacionesIngresadasEquipoNoAdmi(array);
      setGetVacacionesNoAprobadasEquipo(getVacacionesNoAprobadasEquipoSelector);
    } else if (
      vacacionesNoAprobadasEquipoSelector?.length === 0 &&
      getVacacionesNoAprobadasEquipoSelector
    ) {
      setGetVacacionesNoAprobadasEquipo(getVacacionesNoAprobadasEquipoSelector);
    }
  }, [
    noAprobadasSelector,
    vacacionesSelector,
    vacacionesIngresadasSelector,
    vacacionesAprobadasSelector,
    vacacionesIngresadasEquipoSelector,
    vacacionesAprobadasEquipoSelector,
    vacacionesNoAprobadasEquipoSelector,
  ]);

  const handleChangePrimerTAB = (event, newValue) => {
    setValuePrimerTab(newValue);
  };
  const handleChangeSegundoTAB = (event, newValue) => {
    setValueSegundoTab(newValue);
  };
  const handleCloseModalVacaEquipos = () => {
    setOpenModalModalVacacionesEquipo(false);
  };

  const handleCloseModalEliminarVacacion = () => {
    setOpenCancelar(false);
  };

  const handleOpenModalCancelar = (id, lineas) => {
    setVacacion(lineas.find((item) => item.id == id));
    setOpenCancelar(true);
  };

  const handleOpenModalIngresadasEquipo = (id, lineas) => {
    setOpenModalModalVacacionesEquipo(true);
    setVacacion(lineas.find((item) => item.id == id));
  };

  const handleOpenSolicitud = (id, lineas) => {
    if (id && lineas && lineas.id === id) {
      setOpenSolicitud(true);
      setVacacion(lineas);
    }
  };

  const handleCloseSolicitud = () => setOpenSolicitud(false);

  const subperiodoVacacional = () => {
    navigate(`/subperiodo`)
  };

  const submitDatos = (datos, id) => {
    dispatch(solicitudVacaciones(token, datos, id, empleado.empleadoid))
      .then((id) => {
        handleCloseSolicitud()
        dispatch(vacaciones(token, fechaHoy, empleado.usuarioPortalRh));
        dispatch(vacacionesIngresadas(token, empleado.usuarioPortalRh))
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  const cancelarVacaciones = (datos) => {
    dispatch(cancelarVacacionesMetodo(token, datos, empleado.empleadoid))
      .then((id) => {
        handleCloseModalEliminarVacacion()
        dispatch(vacacionesIngresadas(token, empleado.usuarioPortalRh))
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  const aprobarVacacionesEquipo = (datos) => {
    dispatch(aprobarRechazarLicencia(token, datos))
      .then((id) => {
        handleCloseModalVacaEquipos()
        dispatch(vacacionesIngresadasEquipoFetch(token, empleado.usuarioPortalRh))
        dispatch(vacacionesAprobadasEquipo(token, empleado.usuarioPortalRh))
        dispatch(vacacionesNoAprobadasEquipoFetch(token, empleado.usuarioPortalRh))
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <Box m="1rem 2.5rem">
        <Header
          title={"Vacaciones"}
          subtitle="¡Llegó tu momento de descansar y disfrutar! Solicitá tu licencia de vacaciones en esta sección."
        />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
            <Box sx={{ p: 2 }}>
              {/* <CardWrapper border={false} content={false} sx={{ mt: 2 }}>
                <Box sx={{ p: 2 }}>
                  <List sx={{ py: 0 }}>
                    <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
                      <ListItemAvatar>
                        <Avatar
                          variant="rounded"
                          sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.largeAvatar,
                            backgroundColor: theme.palette.primary[800],
                            color: "#fff",
                          }}
                        >
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        sx={{
                          py: 0,
                          mt: 0.45,
                          mb: 0.45,
                        }}
                        primary={
                          <Typography variant="h3" sx={{ color: "#fff" }}>
                            {empleado.nombre}
                          </Typography>
                        }
                        secondary={
                          <Typography variant="subtitle1" sx={{ color: "primary.light", mt: 0.25 }}>
                            Legajo: 11003882
                          </Typography>
                        }
                      />
                    </ListItem>
                  </List>
                </Box>
                <Divider />
              </CardWrapper> */}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
            {/* <Button
              variant="contained"
              sx={{ color: "inherit", mb: 2 }}
              onClick={subperiodoVacacional}
            >
              Subperiodo Vacacional
            </Button> */}
            {!getVacaciones ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "100%",
                  py: 2,
                }}
              >
                <CircularProgress color="secondary" />
              </Box>
            ) : periodoVacaciones.length > 0 ? (
              <TablaVacaciones
                columnas={COLUMNSVACACIONES}
                lineas={periodoVacaciones}
                handleOpen={handleOpenSolicitud}
                acciones={true}
                // deshabilitar={true}
              />
            ) : (
              <Alert severity="info">
                <AlertTitle>Info</AlertTitle>
                Aún no tienes registros de <strong>Vacaciones</strong>.
              </Alert>
            )}
          </Grid>

          <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
            <Box sx={{ p: 2 }}>
              <TabContext value={valuePrimerTab}>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ fontWeight: "bold", mb: 1 }}
                >
                  MIS SOLICITUDES
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <TabList
                    aria-label="scrollable force tabs example"
                    onChange={handleChangePrimerTAB}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    textColor="secondary"
                    indicatorColor="secondary"
                  >
                    <Tab label="Ingresadas" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                    <Tab label="Mis solicitudes aprobadas" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                    <Tab label="Mis solicitudes no admitidas" value="3" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <Box sx={{ maxWidth: "100%" }}>
                    {!getVacacionesIngresadas ? (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                          py: 2,
                        }}
                      >
                        <CircularProgress color="secondary" />
                      </Box>
                    ) : vacacioneIngresada.length > 0 ? (
                      <Tabla
                        columnas={COLUMNSVACACIONESINGRESADAS}
                        lineas={vacacioneIngresada}
                        handleOpen={handleOpenModalCancelar}
                        acciones={true}
                      />
                    ) : (
                      <Alert severity="info">
                        <AlertTitle>Info</AlertTitle>
                        Aún no tienes registros de{" "}
                        <strong>Vacaciones Ingresadas</strong>.
                      </Alert>
                    )}
                  </Box>
                </TabPanel>
                <TabPanel value="2">
                  {!getVacacionesAprobadas ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                        py: 2,
                      }}
                    >
                      <CircularProgress color="secondary" />
                    </Box>
                  ) : vacacioneAprobadas.length > 0 ? (
                    <Tabla
                      columnas={COLUMNSVACACIONESAPROBADAS}
                      lineas={vacacioneAprobadas}
                    />
                  ) : (
                    <Alert severity="info">
                      <AlertTitle>Info</AlertTitle>
                      Aún no tienes registros de{" "}
                      <strong>Vacaciones Aprobadas</strong>.
                    </Alert>
                  )}
                </TabPanel>
                <TabPanel value="3">
                  {!getVacacionesNoAprobadas ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                        py: 2,
                      }}
                    >
                      <CircularProgress color="secondary" />
                    </Box>
                  ) : vacacionesNoAprob.length > 0 ? (
                    <Tabla
                      columnas={COLUMNSVACACIONESNOAPROBADAS}
                      lineas={vacacionesNoAprob}
                    />
                  ) : (
                    <Alert severity="info">
                      <AlertTitle>Info</AlertTitle>
                      Aún no tienes registros de{" "}
                      <strong>Vacaciones No Aprobadas</strong>.
                    </Alert>
                  )}
                </TabPanel>
              </TabContext>
              {
                lider && (
                  <TabContext value={valueSegundoTab}>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{ fontWeight: "bold", mb: 1 }}
                    >
                      MI EQUIPO
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <TabList
                        aria-label="scrollable force tabs example"
                        onChange={handleChangeSegundoTAB}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        textColor="secondary"
                        indicatorColor="secondary"
                      >
                        <Tab label="Ingresadas" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                        <Tab label="Aprobadas" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                        <Tab label="No admitidas" value="3" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      {!getVacacionesIngresadasEquipo ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            py: 2,
                          }}
                        >
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : vacacionesIngresadasEquipo.length > 0 ? (
                        <Tabla
                          columnas={COLUMNSVACACIONESNEQUIPOINGRESADAS}
                          lineas={vacacionesIngresadasEquipo}
                          acciones={true}
                          handleOpen={handleOpenModalIngresadasEquipo}
                        />
                      ) : (
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          Aún no tienes registros de <strong>Vacaciones ingresadas del equipo</strong>.
                        </Alert>
                      )}
                    </TabPanel>
                    <TabPanel value="2">
                      {!getVacacionesAprobadasEquipo ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            py: 2,
                          }}
                        >
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : vacacionesEquipoAprobadas.length > 0 ? (
                        <Tabla
                          columnas={COLUMNSVACACIONESNEQUIPOAPROBADAS}
                          lineas={vacacionesEquipoAprobadas}
                        />
                      ) : (
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          Aún no tienes registros de <strong>Vacaciones aprobadas del equipo</strong>.
                        </Alert>
                      )}
                    </TabPanel>
                    <TabPanel value="3">
                      {!getVacacionesNoAprobadasEquipo ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            py: 2,
                          }}
                        >
                          <CircularProgress color="secondary" />
                        </Box>
                      ) : vacacionesIngresadasEquipoNoAdmi.length > 0 ? (
                        <Tabla
                          columnas={COLUMNSVACACIONESNEQUIPONOADMI}
                          lineas={vacacionesIngresadasEquipoNoAdmi}
                        />
                      ) : (
                        <Alert severity="info">
                          <AlertTitle>Info</AlertTitle>
                          Aún no tienes registros de <strong>Vacaciones no aprobadas del equipo</strong>.
                        </Alert>
                      )}
                    </TabPanel>
                  </TabContext>
                )
              }
            </Box>
          </Grid>
        </Grid>
      </Box>
      {openSolicitud && (
        <ModalSolicitudVacaciones
          open={openSolicitud}
          handleClose={handleCloseSolicitud}
          vacacion={vacacion}
          onSubmit={submitDatos}
        />
      )}
      {openCancelar && (
        <ModalCancelarVacaciones
          open={openCancelar}
          vacacion={vacacion}
          handleClose={handleCloseModalEliminarVacacion}
          onSubmit={cancelarVacaciones}
        />
      )}
      {openModalVacacionesEquipo && (
        <ModalVacacionesEquipo
          open={openModalVacacionesEquipo}
          handleClose={handleCloseModalVacaEquipos}
          vacacion={vacacion}
          onSubmit={aprobarVacacionesEquipo}
        />
      )}
    </motion.div>
  );
};
export default Vacaciones;
